import { AfterViewInit, Component, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort, Sort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import * as moment from "moment";
import { UserService } from "src/app/shared/user.service";
import { ContractTypeService } from "../../../shared/contract-type.service";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { DeleteDialogComponent } from "../../delete-dialog/delete-dialog.component";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: 'app-attribute-type-list',

  templateUrl: './attribute-type-list.component.html',
  styleUrl: './attribute-type-list.component.css'
})
export class AttributeTypeListComponent implements AfterViewInit {


  // Table columns
  displayedColumns: string[] = [
    "Attribute Name",
    "Default Value",
    "Section",
    "Created By",
    "Last Updated",
    "Action",
  ];

  dataLoading: boolean = false;
  dataSource = new MatTableDataSource<any>();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    public userService: UserService,
    private dialog: MatDialog,
    private toast: ToastrService,
    public service: ContractTypeService,
  ) { }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort
  }

  ngOnInit() {
    this.dataLoading = true;
    this.getAttributes();
  }

  async getAttributes() {
    await this.service.getAttributeList().then((seedAttributes: any) => {
      seedAttributes.forEach((attribute: any) => {
        attribute.updatedDate = moment(attribute.updatedDate).format('lll');
      });
      this.dataSource.data = seedAttributes;
    });
    
    if (this.sort) {
      this.dataSource.sort = this.sort;
      this.dataSource.sort.active = 'Last Updated';
      this.dataSource.sort.direction = 'desc';
      this.customSortData({
        active: 'Last Updated',
        direction: 'desc'
      } as Sort);
    }
    this.dataLoading = false;

  }

  openDeleteConfirmation(id): void {
    const dialogRef =
      this.dialog.open(DeleteDialogComponent, {
        enterAnimationDuration: '400ms',
        exitAnimationDuration: '500ms',
        data: {
          deleteFunction: () => this.delete(id, dialogRef)
        }
      });
  }

  async delete(seedAttributeId: number, dialogRef: MatDialogRef<DeleteDialogComponent>) {
    try {
      await this.service.deleteSeedAttribute(seedAttributeId);
      this.toast.success('The attribute has been deleted successfully!', '');
      dialogRef.close();
      this.getAttributes();
    } catch (error) {
      this.toast.error('Failed to delete the attribute!', '');
    }
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.dataSource.filter = filterValue;

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  customSortData(event: Sort) {
    const data = this.dataSource.data.slice();
    if (!event.active || event.direction === '') {
      this.dataSource.data = data;
      return;
    }

    this.dataSource.data = data.sort((a, b) => {
      const valueA = (a[event.active] || '').toString().toLowerCase();
      const valueB = (b[event.active] || '').toString().toLowerCase();

      return this.compare(valueA, valueB, event.direction === 'asc');
    });

    if (this.paginator) {
      this.paginator.firstPage();
    }
  }

  compare(a: string, b: string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }
}
